export default __webpack_public_path__ + "static/398-e297911ba281ce598506c3f1ade7edfc.gif";